import {Box, Typography} from '@mui/material';
import Lottie from 'lottie-react';
import {useTranslation} from 'react-i18next';

import {AppButton, AppButtonVariant} from '@/app/shared-components';
import {CSpinner} from '@/constants/SpinnerConstants';

import {useViewModelProvider, ViewModelProvider} from './ViewModelContext';
import './styles';

const IdvSubmittedContent = () => {
  const {t} = useTranslation();
  const {isInfoCardVisible, onPressCloseAndNotifyMe, onPressIWillWait} =
    useViewModelProvider();

  return (
    <Box className="idv-submitted-page-container">
      <Box className="idv-submitted-page-content">
        <Box className="loader-container">
          <Box
            component="img"
            src="/assets/images/logo/plaid_circle_logo.svg"
            alt="Plaid Logo"
            className="loader-logo"
          />
          <Lottie
            className="mdk-lottie"
            animationData={CSpinner.ELLIPSE_PATH}
            loop
            autoplay
          />
          <Box
            component="img"
            src="/assets/images/logo/modak-circle-logo.svg"
            alt="Modak Logo"
            className="loader-logo"
          />
        </Box>

        <Typography className="idv-submitted-page-title">
          {t('kyc.idv_submitted.title')}
        </Typography>

        {isInfoCardVisible && (
          <Box className="idv-submitted-page-info-card">
            <Typography className="idv-submitted-page-info-card-text">
              {t('kyc.idv_submitted.card_description')}
            </Typography>
            <Box className="idv-submitted-page-info-card-buttons">
              <AppButton
                id="idv-submitted-close-and-notify-me-button"
                label={t('kyc.idv_submitted.close_and_notify_me_button')}
                variant={AppButtonVariant.onTertiary}
                onClick={onPressCloseAndNotifyMe}
              />
              <AppButton
                id="idv-submitted-i-will-wait-button"
                label={t('kyc.idv_submitted.i_will_wait_button')}
                variant={AppButtonVariant.onPrimary}
                onClick={onPressIWillWait}
              />
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

const IdvSubmittedPage = () => (
  <ViewModelProvider>
    <IdvSubmittedContent />
  </ViewModelProvider>
);

export default IdvSubmittedPage;
